/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAmbulance = createReactComponent("ambulance", "IconAmbulance", [
  ["path", { d: "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  [
    "path",
    {
      d: "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5",
      key: "svg-2"
    }
  ],
  ["path", { d: "M6 10h4m-2 -2v4", key: "svg-3" }]
]);

export { IconAmbulance as default };
//# sourceMappingURL=IconAmbulance.js.map
